window.Estoque = Backbone.Model.extend({

});

const Estoques = Backbone.Collection.extend({
    model: Estoque
});


window.Estoques = Estoques

export {
    Estoques
} 